// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryStatistics_wrapper__uRWa+","header":"CategoryStatistics_header__lnaSI","chart":"CategoryStatistics_chart__kgSN3"};